import React, { useContext, useEffect } from 'react';
import { OrganizationContext } from '../../../containers/Context/OrganizationContext';
import HsSelect from '../../Form/HsSelect';
import { strings } from '../../../assets/strings/all';

function VisibilityStatusSelect(props) {
  const { organization } = useContext(OrganizationContext);
  const { onChange } = props;
  const { visibilityStatuses = [] } = organization || {};
  const { cases } = strings;

  useEffect(() => {
    if (props.value && !props.value.name) {
      onChange({ name: props.value });
    }
  }, []);

  const formattedLabel = (option) => {
    const { name, description } = option;
    return (
      <div className="select-option-wrapper">
        <div className="select-option-name">{name}</div>
        <div className="select-option-description">{description}</div>
      </div>
    );
  };

  return (
    <>
      <HsSelect
        label={cases.visibility}
        placeholder={cases.visibility}
        options={[{ label: cases.visibility, options: visibilityStatuses }]}
        getOptionLabel={(option) => formattedLabel(option)}
        defaultValue={props.value}
        onChange={onChange}
        isClearable={false}
        selected={props.value}
        {...props}
        // value={caseData.visibilityStatus}
      />
    </>
  );
}

export default VisibilityStatusSelect;
